/* global axios */
import ApiClient from '../ApiClient';

class AiBotAnswersAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/answers`, { accountScoped: true });
  }

  get({ matchType, page, q } = {}) {
    return axios.get(this.url, { params: { match_type: matchType, page, q } });
  }

  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData);
  }
}

export default AiBotAnswersAPI;
